import { useEffect, useState } from "react";
import Tooltip from "@tippyjs/react";

import { getTrans as t } from "../../Localization/translations";
import Helper from "../../Helper";

function Keyinformation({ contractdetail, extrafiledcontractdetail, customerPermission }) {

    const [attribute, setAttribute] = useState([]);
    const [extrafiledcontract, setExtraFiled] = useState([]);
    // Stored snapshot from ContractKeyInformation; null for contracts not yet activated
    const ki = contractdetail.key_information;

    useEffect(() => {
        setExtraFiled(extrafiledcontractdetail)
        setAttribute([
            { attribute: contractdetail.Contract.contractattribute1 },
            { attribute: contractdetail.Contract.contractattribute2 },
            { attribute: contractdetail.Contract.contractattribute3 },
            { attribute: contractdetail.Contract.contractattribute4 },
            { attribute: contractdetail.Contract.contractattribute5 },
            { attribute: contractdetail.Contract.contractattribute6 },
            { attribute: contractdetail.Contract.contractattribute7 },
            { attribute: contractdetail.Contract.contractattribute8 },
            { attribute: contractdetail.Contract.contractattribute9 },
            { attribute: contractdetail.Contract.contractattribute10 },
            { attribute: contractdetail.Contract.contractattribute11 },
            { attribute: contractdetail.Contract.contractattribute12 },
            { attribute: contractdetail.Contract.contractattribute13 },
            { attribute: contractdetail.Contract.contractattribute14 },
            { attribute: contractdetail.Contract.contractattribute15 },
        ]);
    }, [])

    return (
        <div className="accordion-item  mb-4">
            <h2 className="accordion-header" id="panelsStayOpen-headingFour">
                <button className="accordion-button collapsed" style={{ color: "#008DC1" }} type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="false" aria-controls="panelsStayOpen-collapseFour">
                    <b>{t("Key Information")}</b>
                </button>
            </h2>
            <div id="panelsStayOpen-collapseFour" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingFour">
                <div className="accordion-body">
                    <div className="col-md-12">
                        <div className="">
                            <div className="col ">
                                <div className="col text-right"></div>
                            </div>
                            <div className="card-body">
                                <div className=" row">
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className="col-form-label">
                                            {t("Last Payment Amount")}{" "}
                                            <Tooltip
                                                content={t("LastPaymentAmount_Tooltip")}
                                            >
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                            <span className="view-label p">
                                                {ki ? (ki.last_payment_amount ?? "None") : (contractdetail.receipt_amt ? contractdetail.receipt_amt : "None")}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className="col-form-label">
                                            {t("Amount Billed")}{" "}
                                            <Tooltip content={t("AmountBilled_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                            <span className="view-label p">
                                                {Helper.Amount(ki ? ki.amount_billed : contractdetail.amount_billed)}
                                            </span>

                                        </div>
                                    </div>
                                </div>
                                <div className=" row">
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className="col-form-label">
                                            {t("Next Due Amount")}{" "}
                                            <Tooltip
                                                content={t("NextDueAmount_Tooltip")}
                                            >
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                            <span className="view-label p">
                                                {Helper.Amount(ki ? ki.next_due_amount : (contractdetail.nextdue_amt && contractdetail.nextdue_amt.total_amount))}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className="col-form-label">
                                            {t("Amount Unbilled")}{" "}
                                            <Tooltip
                                                content={t("AmountUnbilled_Tooltip")}
                                            >
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                            <span className="view-label p">
                                                {Helper.Amount(ki ? ki.amount_unbilled : contractdetail.amount_unbilled)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className=" row">
                                    {/* <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className=" col-form-label">
                                            {t("Payoff Amount")}{" "}
                                            <Tooltip
                                                content={t("PayoffAmount_Tooltip")}
                                            >
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                            <span className="view-label p">
                                                {Helper.Amount(
                                                    contractdetail.totalpayoff + contractdetail.amount_unbilled
                                                )}
                                            </span>
                                        </div>
                                    </div> */}
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className=" col-form-label">{t('Deposit Amount')} <Tooltip content={t("DepositAmount_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                            <span className="view-label p">
                                                {Helper.Amount(contractdetail.Contract.deposit_amount)}
                                            </span>
                                        </div>
                                    </div>
                                    {/* </div> */}
                                    {/* <div className=" row"> */}
                                    {/* <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }} >
                                        <label className=" col-form-label">
                                            {t("Concurrent Contracts")}{" "}
                                            <Tooltip
                                                content={t("ConcurrentContracts_Tooltip")}
                                            >
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }} >
                                            <span className=" view-label p">
                                                {contractdetail.totalContract}
                                            </span>
                                        </div>
                                    </div> */}
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }} >
                                        <label className=" col-form-label">
                                            {t("Amount Due")}{" "}
                                            <Tooltip content={t("AmountDue_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }} >
                                            <span className=" view-label p">
                                                {Helper.Amount(ki ? ki.amount_due : contractdetail.amount_due)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className=" row">
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className=" col-form-label">
                                            {t("Last Payment Date")}{" "}
                                            <Tooltip
                                                content={t("LastPaymentDate_Tooltip")}
                                            >
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                            <span className=" view-label p">
                                                {(ki ? ki.last_payment_date : contractdetail.receipt_date)
                                                    ? Helper.DateNormal(ki ? ki.last_payment_date : contractdetail.receipt_date)
                                                    : "None"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className=" col-form-label">
                                            {t("Days Past Due")}{" "}
                                            <Tooltip content={t("DayPastDue_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                            <span className=" view-label p">
                                                {ki ? (ki.days_past_due ?? 0) : (contractdetail.duedata ? Helper.DueDays(contractdetail.duedata) : 0)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className=" row">
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className=" col-form-label">
                                            {t("Next Due Date")}{" "}
                                            <Tooltip content={t("NextDueDate_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                            <span className=" view-label p">
                                                {(ki ? ki.next_due_date : contractdetail.nextdue_date)
                                                    ? Helper.DateNormal(ki ? ki.next_due_date : contractdetail.nextdue_date)
                                                    : "None"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className=" col-form-label">
                                            {t("Remaining Term (Months)")}
                                            <Tooltip
                                                content={t("RemainingTerm(Months)_Tooltip")}
                                            >
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                            <span className=" view-label p">
                                                {ki ? ki.remaining_term_months : contractdetail.invoicecount === 0
                                                    ? contractdetail.contract_remaining_term
                                                    : contractdetail.Contract.end_date <= Helper.DatePicker(new Date())
                                                        ? 0
                                                        :
                                                        contractdetail.contract_remaining_term
                                                    // Helper.MonthDifference(
                                                    //     new Date(),
                                                    //     new Date(contractdetail.Contract.end_date)
                                                    // )
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className=" row">
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className=" col-form-label">
                                            {t("Auto Pay")}{" "}
                                            <Tooltip content={t("AutoPay_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                            <span className=" view-label p">
                                                {ki ? (ki.auto_pay ? "Yes" : "No") : "No"}
                                            </span>
                                        </div>
                                    </div>
                                    {/* {
                                        customerPermission !== 'Customer' ?
                                            contractdetail.Contract.contract_type === "Rental" ?
                                                "" :

                                                contractdetail.Contract.contract_type !== "Loan" ? (
                                                    <>
                                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                                            <label className=" col-form-label">
                                                                {t("IRR/Interest p.a.")}{" "}
                                                                <Tooltip
                                                                    content={t("IRR/Interestp.a_Tooltip")}
                                                                >
                                                                    <i className="fa fa-light fa-circle-info"></i>
                                                                </Tooltip>
                                                            </label>
                                                            <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                                                <span className=" view-label p">
                                                                    {Helper.Amount(contractdetail.Contract.iir)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                                            <label className=" col-form-label">
                                                                {t("Interest Rate")}{" "}
                                                                <Tooltip
                                                                    content={t("InterestRate_Tooltip")}
                                                                >
                                                                    <i className="fa fa-light fa-circle-info"></i>
                                                                </Tooltip>
                                                            </label>
                                                            <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                                                <span className=" view-label p">
                                                                    {Helper.Amount(contractdetail.Contract.iir)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            : ""

                                    } */}
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className=" col-form-label">
                                            {t("Termination Date")}{" "}
                                            <Tooltip
                                                content={t("TerminationDate_Tooltip")}
                                            >
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                            <span className=" view-label p">
                                                {contractdetail.Contract.termination_date
                                                    ? Helper.Dateview(contractdetail.Contract.termination_date)
                                                    : "None"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                  <div className=" row">
                                 {
                                contractdetail.Contract.contract_type == "Loan" ? (
                                                    <>
                                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                                            <label className=" col-form-label">
                                                                {t("Interest Rate Type")}{" "}
                                                                <Tooltip
                                                                    content={t("InterestRateType_Tooltip")}
                                                                >
                                                                    <i className="fa fa-light fa-circle-info"></i>
                                                                </Tooltip>
                                                            </label>
                                                            <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                                                <span className=" view-label p">
                                                                    {(contractdetail.Contract.interest_rate_type)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </>
                                            )
                                            : ""
                                        }

                                        {
                                        customerPermission !== 'Customer' ?
                                            contractdetail.Contract.contract_type === "Rental" ?
                                                "" :

                                                contractdetail.Contract.contract_type !== "Loan" ? (
                                                    <>
                                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                                            <label className=" col-form-label">
                                                                {t("IRR/Interest p.a.")}{" "}
                                                                <Tooltip
                                                                    content={t("IRR/Interestp.a_Tooltip")}
                                                                >
                                                                    <i className="fa fa-light fa-circle-info"></i>
                                                                </Tooltip>
                                                            </label>
                                                            <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                                                <span className=" view-label p">
                                                                    {Helper.Amount(contractdetail.Contract.iir)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                                            <label className=" col-form-label">
                                                                {t("Interest Rate")}{" "}
                                                                <Tooltip
                                                                    content={t("InterestRate_Tooltip")}
                                                                >
                                                                    <i className="fa fa-light fa-circle-info"></i>
                                                                </Tooltip>
                                                            </label>
                                                            <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                                                <span className=" view-label p">
                                                                    {Helper.Amount(contractdetail.Contract.iir)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            : ""

                                    }
                                    </div>

                                    {
                                        contractdetail.Contract.interest_rate_type==="Fixed" ? "":
                                        contractdetail.Contract.contract_type === "Loan" ?
                                <div className=" row">
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className=" col-form-label">
                                            {t("Base Rate")}{" "}
                                            <Tooltip content={t("BaseRate_Tooltip")}>
                                            <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                            <span className=" view-label p">
                                                {contractdetail.Contract.base_rate ? contractdetail.Contract.base_rate : "0.00"}
                                            </span>     

                                        </div>
                                        </div>
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className=" col-form-label">
                                           {t("Margin")}{" "}
                                        <Tooltip content={t("Margin_Tooltip")}>
                                            <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                            <span className=" view-label p">
                                                {contractdetail.Contract.margin ? contractdetail.Contract.margin : "0.00"}
                                            </span>     

                                        </div>
                                        </div>
                                        </div>
                                        :
                                        ""
                                    }

                                <div className=" row">
                                    {/* <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className=" col-form-label">
                                            {t("Net Investment")}{" "}
                                            <Tooltip content={t("NetInvestment_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                            <span className=" view-label p">
                                                {
                                                    contractdetail.Contract.status === "Active" ?

                                                        contractdetail.Contract.contract_type === "Rental" ?
                                                            (
                                                                // Helper.Amount(contractdetail.totalRent * contractdetail.Contract.contract_term + contractdetail.residalvalue)
                                                                Helper.Amount(contractdetail.amount_billed_not_paid)
                                                            )
                                                            :
                                                            (
                                                                Helper.Amount(contractdetail.amount_billed_not_paid + contractdetail.total_capital_recovery)
                                                            )
                                                        : 0.00
                                                }
                                            </span>
                                        </div>
                                    </div> */}
                                    
                                </div>
                                <div className=" row">
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className="col-form-label ">
                                            {t("Term (Months)")}{" "}
                                            <Tooltip content={t("Term_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                            <span className="view-label p">
                                                {contractdetail.Contract.contract_term}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className="col-form-label">
                                            {t("Amount Financed")}{" "}
                                            <Tooltip
                                                content={t("Amountfinanced_Tooltip")}
                                            >
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                            <span className="view-label p">
                                                {Helper.Amount(ki && ki.amount_financed != null ? ki.amount_financed - contractdetail.Contract.deposit_amount : contractdetail.Contract.financed_amount - contractdetail.Contract.deposit_amount)}
                                            </span>
                                        </div>
                                    </div>
                                    {/* <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className="col-form-label ">
                                            {t("Payment Rule")}{" "}
                                            <Tooltip content={t("PaymentRule_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                            <span className="view-label p">
                                                {contractdetail.Contract.paymentrule}
                                            </span>
                                        </div>
                                    </div> */}
                                    {
                                        contractdetail.Contract.contract_type === "Rental"?
                                            "" :

                                            <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                                <label className="col-form-label ">
                                                    {t("Ending book value")}{" "}
                                                    <Tooltip content={t("Endingbookvalue_Tooltip")}>
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label>
                                                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                                    <span className="view-label p">
                                                        {Helper.Amount(ki ? ki.ending_book_value : contractdetail.total_capital_recovery)}
                                                    </span>
                                                </div>
                                            </div>}
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className="col-form-label">
                                            {t("Payment Frequency")}{" "}
                                            <Tooltip
                                                content={t("PaymentFrequency_Tooltip")}
                                            >
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                            <span className="view-label p">
                                                {(contractdetail.Contract.paymentfrequency)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                               
                                        
                                <div className=" row">
                                    {extrafiledcontract.map((key, index) => (
                                        <>
                                            <div
                                                className="col-xl-6 d-flex"
                                                style={{
                                                    display:
                                                        key.enable === "True" ? true : "none",
                                                    justifyContent: 'space-between'
                                                }}
                                            >
                                                <label
                                                    className="col-form-label"
                                                    style={{
                                                        display:
                                                            key.enable === "True" ? true : "none",
                                                    }}
                                                >
                                                    {key.label}
                                                </label>
                                                <div
                                                    className="col-xl-6 d-flex"
                                                    style={{
                                                        display:
                                                            key.enable === "True" ? true : "none",
                                                        justifyContent: 'space-between'
                                                    }}
                                                >
                                                    <span
                                                        className="view-label p"
                                                        style={{
                                                            display:
                                                                key.enable === "True" ? true : "none",
                                                        }}
                                                    >
                                                        {attribute[index]["attribute"]
                                                            ? attribute[index]["attribute"]
                                                            : "None"}
                                                    </span>
                                                </div>
                                            </div>
                                        </>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Keyinformation;